import { Modal } from 'semantic-ui-react';
import TaskHistory from './TaskHistory';
import React from 'react';

interface TaskHistoryModalProps {
  isHistoryModalVisible: boolean;
  setIsHistoryModalVisible: (visible: boolean) => void;
  selectedTask: any;
}

const TaskHistoryModal = (props: TaskHistoryModalProps) => {
  const { isHistoryModalVisible, setIsHistoryModalVisible, selectedTask } = props;

  return <Modal
    open={isHistoryModalVisible}
    onClose={() => setIsHistoryModalVisible(false)}
    size="large"
  >
    <Modal.Header>Task Execution History</Modal.Header>
    <Modal.Content>
      <TaskHistory taskId={selectedTask?.is_periodic ? selectedTask?.periodic_task?.id : selectedTask?.registry_task?.id} />
    </Modal.Content>
  </Modal>
}

export default TaskHistoryModal;

